import React, {Component} from "react";
import {withRouter, RouteComponentProps} from "react-router-dom";
import {connect} from "react-redux";

import {hallsStoreSelectors} from "../../../store/store";

import LicenseMissingSeed from "./States/LicenseMissingSeed/LicenseMissingSeed.component";
import LicenseIdConfirmation from "./States/LicenseIdConfirmation/LicenseIdConfirmation.component";
import LicenseAwaitLicense from "./States/LicenseAwaitLicense/LicenseAwaitLicense.component";
import LicenseApplied from "./States/LicenseApplied/LicenseApplied.component";
import LicenseNoPermission from "./States/LicenseNoPermission/LicenseNoPermission.component";

import {HallServer} from "../../../reducers/inspectingHall.reducer";

import "./LicenseRequest.component.scss";
import {checkPermission} from "../../../../../utils/Authorization/authorization";

export interface LicenseRequestProps extends RouteComponentProps {
    inspectingServer: HallServer;
    serverLicenseState: number;
    allow: boolean;
}

class LicenseRequest extends Component<LicenseRequestProps, {}> {
    render() {
        return (
            <div className="license-resquest">
                {this.props.serverLicenseState == 1 &&
                    (checkPermission("upload_seed") ||
                        checkPermission("manage_licensing")) && (
                        <LicenseMissingSeed
                            serverId={this.props.match.params["serverId"]}
                        />
                    )}
                {this.props.serverLicenseState == 1 &&
                    !(
                        checkPermission("upload_seed") ||
                        checkPermission("manage_licensing")
                    ) && (
                        <LicenseNoPermission
                            message="The license process hasn't started yet. Please try again later or contact an administrator."/>
                    )}
                {this.props.serverLicenseState == 2 &&
                    checkPermission("manage_licensing") && (
                        <LicenseIdConfirmation
                            serverId={this.props.match.params["serverId"]}
                        />
                    )}
                {this.props.serverLicenseState == 2 &&
                    !checkPermission("manage_licensing") && (
                        <LicenseNoPermission
                            message="The license process is waiting for an administrator confirmation. Please check again later or contact an administrator."/>
                    )}
                {this.props.serverLicenseState == 3 &&
                    (checkPermission("manage_licensing") ||
                        checkPermission("download_license")) &&
                    this.props.inspectingServer && (
                        <LicenseAwaitLicense
                            allow={this.props.allow}
                            serverId={this.props.match.params["serverId"]}
                            serverName={this.props.inspectingServer.name}/>
                    )}
                {this.props.serverLicenseState == 3 &&
                    !checkPermission("download_license") &&
                    !checkPermission("manage_licensing") && (
                        <LicenseNoPermission
                            message="The license process is waiting for an administrator confirmation. Please check again later or contact an administrator."/>
                    )}
                {this.props.serverLicenseState == 4 &&
                    (checkPermission("manage_licensing") ||
                        checkPermission("download_license") ||
                        checkPermission("view_license")) &&
                    this.props.inspectingServer && (
                        <LicenseApplied
                            allow={this.props.allow}
                            serverId={this.props.match.params["serverId"]}
                            serverName={this.props.inspectingServer.name}
                            serverIsOnline={this.props.inspectingServer.is_online}
                            systemServerLicense={this.props.inspectingServer.current_data}
                            lastOnline={this.props.inspectingServer['last_online']}
                        />
                    )}
                {this.props.serverLicenseState == 4 &&
                    !(
                        checkPermission("manage_licensing") ||
                        checkPermission("download_license") ||
                        checkPermission("view_license")
                    ) && (
                        <LicenseNoPermission
                            message="The current state in the license process is not available. Please check again later or contact an administrator for permissions."/>
                    )}
            </div>
        );
    }
}

checkPermission("upload_seed") ||
checkPermission("download_license") ||
checkPermission("manage_licensing") ||
checkPermission("view_license");

const mapStateToProps = state => ({
    inspectingServer: hallsStoreSelectors.inspectingServer(state),
    serverLicenseState: hallsStoreSelectors.serverLicenseState(state)
});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(LicenseRequest));
